export default "__VITE_ASSET__Do8Wnfgj__"